import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAlert from './VaAlert.vue'

export const VaAlert = withConfigTransport(_VaAlert)
